export function isLikelyJsonVector(value: string | null | undefined): boolean {
    if (!value) return false;
    const trimmed = String(value).trim();
    return trimmed.startsWith('[');
}

export function decodeBase64ToUint8Array(base64: string): Uint8Array {
    if (!base64) return new Uint8Array();

    const sanitized = base64
        .trim()
        .replace(/\s+/g, '')
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const padLength = sanitized.length % 4 === 0 ? 0 : 4 - (sanitized.length % 4);
    const padded = padLength > 0 ? sanitized + '='.repeat(padLength) : sanitized;

    try {
        const binary = atob(padded);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    } catch (err) {
        console.warn('[vectorUtils] base64 decode failed; returning empty', err);
    }

    return new Uint8Array();
}

const POPCOUNT_TABLE = (() => {
    const table = new Uint8Array(256);
    for (let i = 0; i < 256; i++) {
        let v = i;
        let count = 0;
        while (v) {
            v &= v - 1;
            count++;
        }
        table[i] = count;
    }
    return table;
})();

export function hammingDistance(a?: Uint8Array, b?: Uint8Array): number {
    if (!a || !b || a.length === 0 || b.length === 0 || a.length !== b.length) {
        return Number.POSITIVE_INFINITY;
    }
    let distance = 0;
    for (let i = 0; i < a.length; i++) {
        distance += POPCOUNT_TABLE[a[i] ^ b[i]];
    }
    return distance;
}

export function hammingSimilarityPercent(a?: Uint8Array, b?: Uint8Array): number {
    if (!a || !b || a.length === 0 || b.length === 0 || a.length !== b.length) {
        return 0;
    }
    const bits = a.length * 8;
    const distance = hammingDistance(a, b);
    if (!isFinite(distance)) {
        return 0;
    }
    const matches = Math.max(0, bits - distance);
    return Math.max(0, Math.min(100, (matches / bits) * 100));
}
